import { useState } from "react";
import Footer from "../../../core/common/Footer";
import { useParams } from "react-router";
import ValidCandidates from "./ValidCandidates";
import InvalidCandidates from "./InvalidCandidates";
import AssignOrderToCandidate from "./AssignOrderToCandidate";
import BackButton from "../../../core/common/BackButton";
import { all_routes } from "../../router/all_routes";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const AssignOrder = () => {
  const { orderId } = useParams();

  const tabs = [
    {
      id: "assignOrder",
      label: "Assign Order",
      icon: <UserAddOutlined />,
      component: <AssignOrderToCandidate />,
    },
    {
      id: "validCandidates",
      label: "Valid Candidates",
      icon: <CheckCircleOutlined />,
      component: <ValidCandidates />,
    },
    {
      id: "invalidCandidates",
      label: "Invalid Candidates",
      icon: <CloseCircleOutlined />,
      component: <InvalidCandidates />,
    },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const activeItem = tabs.find((i) => i.id == activeTab);
  const activeComponent = activeItem ? activeItem.component : <></>;

  return (
    <div className="page-wrapper">
      <div className="content p-0 p-md-3">
        <div className="mt-3 ">
          <div className="justify-content-end d-flex d-md-none mb-2 px-3 px-md-1">
            <BackButton route={all_routes.manageOrder} />
          </div>
          <div className="mb-4 px-3 px-md-1 d-flex justify-content-between align-items-center">
            <div className="text-dark">
              <span className="fw-bold">Order Id:</span> {orderId}
            </div>
            <div className="d-none d-md-block">
              <BackButton route={all_routes.manageOrder} />
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`invite-btn d-inline-flex align-items-center gap-2 ${
                  activeTab === tab.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
          <div className="mt-4 ">{activeComponent}</div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AssignOrder;
